<template>
<div class="terms">
    <div class="description" v-html="pageText"></div>
  </div>
</template>

<script>
import PageHTML from '@/views/html/terms.html';

export default {
  name: 'Terms',
  metaInfo: {
    title: 'ВХ для КС - Условия использования',
    link: [
      { rel: 'canonical', href: 'https://cssoftshop.ru/terms' },
    ],
    meta: [
      { name: 'description', content: 'Условия использования ВХ для КС2 (CS2).' },
    ],
  },
  data() {
    return {
      pageText: PageHTML,
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">

.description
    color: white
    text-align: left
    max-width: 900px
    margin: 0px auto
</style>
